export const TableTestIdFactory = {
    // bases
    getTableBase: () => 'table',
    getTableBodyBase: () => [TableTestIdFactory.getTableBase(), 'body'].join('-'),
    getTableRowBase: () => [TableTestIdFactory.getTableBase(), 'row'].join('-'),
    getTableColumnHeaderBase: () => [TableTestIdFactory.getTableBase(), 'column-header'].join('-'),
    getTableCellBase: () => [TableTestIdFactory.getTableBase(), 'cell'].join('-'),
    getTableEmptyBase: () => [TableTestIdFactory.getTableBase(), 'empty'].join('-'),
    getTableLoadingBase: () => [TableTestIdFactory.getTableBase(), 'loading'].join('-'),
    getTableSelectBase: () => 'select',
    // for test id generation
    getTableRootTestId: (testId) => [TableTestIdFactory.getTableBase(), testId].join('-'),
    getTableBodyTestId: (testId) => [TableTestIdFactory.getTableBodyBase(), testId].join('-'),
    getTableRowTestId: (dataAccessorId, testId) => [
        TableTestIdFactory.getTableRowBase(),
        TableTestIdFactory.internalGenerateTableRowTestId(dataAccessorId, testId),
    ].join('-'),
    getTableColumnHeaderTestId: (testId) => [TableTestIdFactory.getTableColumnHeaderBase(), testId].join('-'),
    getTableHeadTestId: (columnId, testId) => [
        TableTestIdFactory.getTableColumnHeaderBase(),
        TableTestIdFactory.internalGenerateTableHeadTestId(columnId, testId),
    ].join('-'),
    getTableCellTestId: (dataAccessorId, columnId, testId) => [
        TableTestIdFactory.getTableCellBase(),
        TableTestIdFactory.internalGenerateTableCellTestId(dataAccessorId, columnId, testId),
    ].join('-'),
    getTableSelectAllTestId: (testId) => [TableTestIdFactory.getTableSelectBase(), testId].join('-'),
    getTableSelectCellTestId: (dataAccessorId, testId) => [TableTestIdFactory.getTableSelectBase(), dataAccessorId, testId].join('-'),
    getTableEmptyTestId: (testId) => [TableTestIdFactory.getTableEmptyBase(), testId].join('-'),
    getTableLoadingTestId: (testId) => [TableTestIdFactory.getTableLoadingBase(), testId].join('-'),
    // internal don't use outside of component
    internalGenerateTableHeadTestId: (columnId, testId) => [columnId, testId].join('-'),
    internalGenerateTableRowTestId: (dataAccessorId, testId) => [dataAccessorId, testId].join('-'),
    internalGenerateTableCellTestId: (dataAccessorId, columnId, testId) => [dataAccessorId, columnId, testId].join('-'),
};
